<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link to="/school/learning-management" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>Learning Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Assignments
            </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <modal :show.sync="modals.assignmentAnswerModal" modal-classes="modal-dialog-centered modal-xl">
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <div class="table-responsive mt-2">
                                    <table class="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Student Name</th>
                                                <th>CA Score</th>
                                                <th>Exam Score</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in homeworanswerkitem" :key="item.Id">
                                                <td>{{ item.StudentName }}</td>
                                                <td>{{ item.UploadedDate | formatDate }}</td>
                                                <td><a :href="item.DocPath" target="_blank"
                                                        class="btn btn-dark btn-sm"><i class="fa fa-download"></i>
                                                        Download </a> </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="default" @click="modals.assignmentAnswerModal = false">Close
                            </base-button>
                        </template>
                    </modal>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card bg-secondary border-0 mb-0">
                                <div class="card-body">
                                    <div class="form-horizontal">
                                        <form role="form" @submit.prevent="submitdata">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Session</label>
                                                                <select v-model="SessionIdval" class="form-control"
                                                                    :disabled="!Sessionitems" @change="getregterm()">
                                                                    <option value="0" v-if="!Sessionitems">⏳ Loading...
                                                                    </option>
                                                                    <option value="0" v-else>- Select Session -</option>
                                                                    <option v-for="item in Sessionitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.SchSession }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Term</label>
                                                                <select v-model="TermIdval" class="form-control"
                                                                    :disabled="!termitems"
                                                                    @change="getclassinsubjectassigned()">
                                                                    <option value="0" v-if="!termitems">⏳ Loading...
                                                                    </option>
                                                                    <option value="0" v-else>- Select Term -</option>
                                                                    <option v-for="item in termitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.SchTerm }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Class</label>
                                                                <select v-model="ClassIdval" class="form-control"
                                                                    :disabled="!classitems"
                                                                    @change="getoptioninsubjectassigned()">
                                                                    <option value="0" v-if="!classitems">⏳ Loading...
                                                                    </option>
                                                                    <option value="0" v-else>- Select Class -</option>
                                                                    <option v-for="item in classitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.Sch_Class }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Option</label>
                                                                <select v-model="OptionIdval" class="form-control"
                                                                    :disabled="!optionitems"
                                                                    @change="getarminsubjectassigned()">
                                                                    <option value="0" v-if="!optionitems">⏳ Loading...
                                                                    </option>
                                                                    <option value="0" v-else>- Select Option -</option>
                                                                    <option v-for="item in optionitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.ClassOption }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Arm</label>
                                                                <select v-model="ArmIdval" class="form-control"
                                                                    :disabled="!armitems"
                                                                    @change="getsubjectinsubjectassigned()">
                                                                    <option value="0" v-if="!armitems">⏳ Loading...
                                                                    </option>
                                                                    <option value="0" v-else>- Select Arm -</option>
                                                                    <option v-for="item in armitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.SectionName }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Subject</label>
                                                                <select v-model="SubjectIdval" class="form-control"
                                                                    :disabled="!subjectitems" @change="gethomework()">
                                                                    <option value="0" v-if="!subjectitems">⏳ Loading...
                                                                    </option>
                                                                    <option value="0" v-else>- Select Subject -</option>
                                                                    <option v-for="item in subjectitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.SchSubject }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label>Title</label>
                                                                <vue-editor v-model="Titleval">
                                                                </vue-editor>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label>Description</label>
                                                                <vue-editor v-model="Descripval">
                                                                </vue-editor>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label>Submission Date</label>
                                                                <input type="date" min="0" v-model="SubmissionDateval"
                                                                    class="form-control" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <span v-if="uploadedimage">
                                                                <i class="fa fa-upload"></i>
                                                            </span>
                                                            <input type="file" id="file" ref="file"
                                                                v-on:change="handleFileUpload()" />
                                                            <br />
                                                            <button class="btn btn-outline-secondary"
                                                                @click.prevent="submitFile()">
                                                                <i class="fa fa-upload"></i>Upload
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-center mb-3">
                                                <button type="submit" class="btn btn-primary my-4">
                                                    Submit
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="table-responsive mt-2">
                                <table class="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Submission Date</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in homeworkitem" :key="item.Id">
                                            <td v-html="item.Title"></td>
                                            <td>{{ item.SubmissionDate | formatDate }}</td>

                                            <td>
                                                <button class="btn btn-secondary btn-sm" v-on:click="edititem(item.Id)">
                                                    <i class="fa fa-edit"></i> Edit
                                                </button>

                                                <button class="btn btn-secondary btn-sm"
                                                    v-on:click="gethomeworkanswer(item.Id)">
                                                    <i class="fa fa-eye"></i> View Student Submited
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import moment from "moment";
import Alert from "@/mixins/Alert.mixins"
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from "@/components/PageSpinner";
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin";
export default {
    name: "homework",
    mixins: [CheckStaffUser, Alert],
    components: {
        PageSpinner, VueEditor
    },
    data() {
        return {
            accessDetails: null,
            dataid: 0,
            ClassIdval: 0,
            OptionIdval: 0,
            ArmIdval: 0,
            SessionIdval: 0,
            TermIdval: 0,
            StudIdval: 0,
            SubjectIdval: 0,
            Titleval: "",
            Descripval: "",
            DocPathval: "",
            uploadedimage: "",
            SubmissionDateval: "",
            Sessionitems: null,
            termitems: null,
            classitems: null,
            optionitems: null,
            armitems: null,
            subjectitems: null,
            homeworkitem: null,             
            homeworanswerkitem: null,
            process: "N",
            onloader: "none",
            modals: {
                assignmentAnswerModal: false
            }
        };
    },
    methods: {       
        edititem (Id) {
            this.dataid = Id;
            this.process = "U";
            this.onloader = "flex";
            this.$store
                .dispatch("gethomeworkbyid", Id)
                .then((resp) => {
                    this.Titleval = resp.Title;
                    this.Descripval = resp.Descrip;
                    this.DocPathval = resp.DocPath;
                    this.uploadedimage = resp.DocPath;
                    this.SubmissionDateval = this.frontEndDateFormat(resp.SubmissionDate);
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    console.log(err);
                    //this.$store.dispatch('logout')
                });
        },
        submitdata () {
            let Id = this.dataid;
            let ClassId = this.ClassIdval;
            let OptionId = this.OptionIdval;
            let ArmId = this.ArmIdval;
            let SessionId = this.SessionIdval;
            let TermId = this.TermIdval;
            let SubjectId = this.SubjectIdval;
            let StudId = 1;
            let Title = this.Titleval;
            let Descrip = this.Descripval;
            let DocPath = this.DocPathval;
            let SubmissionDate = this.SubmissionDateval;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userdata = {
                Id,
                ClassId,
                OptionId,
                ArmId,
                SubjectId,
                StudId,
                Title,
                SessionId,
                TermId,
                Descrip,
                DocPath,
                SubmissionDate,
                processop,
                username,
                accesskey,
            };
            this.onloader = "flex";
            this.$store
                .dispatch("homeworkregistration", userdata)
                .then((resp) => {
                    this.homeworkitem = resp;
                    this.Titleval = "";
                    this.Descripval = "";
                    this.DocPathval = "";
                    this.SubmissionDateval = "";
                    this.onloader = "none";
                    this.ShowAlertSuccess('Submitted Successfully', '');
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        gethomework () {
            let Id = 1;
            let ClassId = this.ClassIdval;
            let OptionId = this.OptionIdval;
            let ArmId = this.ArmIdval;
            let SubjectId = this.SubjectIdval;
            let StudId = 1;
            let SessionId = this.SessionIdval;
            let TermId = this.TermIdval;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userdata = {
                Id,
                ClassId,
                OptionId,
                ArmId,
                SubjectId,
                StudId,
                SessionId,
                TermId,
                username,
                accesskey,
            };
            this.onloader = "flex";
            this.$store
                .dispatch("gethomework", userdata)
                .then((resp) => {
                    this.homeworkitem = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        gethomeworkanswer(HomeworkId) {
            this.onloader = 'flex';
            this.$store.dispatch('gethomeworkanswer', HomeworkId)
                .then(resp => {
                    this.homeworanswerkitem = resp;
                    this.onloader = 'none';
                    this.assignmentAnswerModal = true;
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getregsession () {
            this.termitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.Sessionitems = null;
            this.subjectitems = null;
            this.homeworkitem = null;
            this.SessionIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("getregsession")
                .then((resp) => {
                    this.Sessionitems = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getregterm () {
            this.classitems = null;
            this.termitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.homeworkitem = null;
            this.TermIdval = 0;
            let SessionId = this.SessionIdval;
            if (SessionId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("getregterm", SessionId)
                    .then((resp) => {
                        this.termitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getclassinsubjectassigned () {
            this.classitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.subjectitems = null;
            this.homeworkitem = null;
            this.ClassIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("getclassinsubjectassigned")
                .then((resp) => {
                    this.classitems = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getoptioninsubjectassigned () {
            this.optionitems = null;
            this.armitems = null;
            this.subjectitems = null;
            this.homeworkitem = null;
            this.OptionIdval = 0;
            this.onloader = "flex";
            let ClassId = this.ClassIdval;
            if (ClassId > 0) {
                this.$store
                    .dispatch("getoptioninsubjectassigned", ClassId)
                    .then((resp) => {
                        this.optionitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getarminsubjectassigned () {
            this.armitems = null;
            this.subjectitems = null;
            this.homeworkitem = null;
            this.ArmIdval = 0;
            this.onloader = "flex";
            let OptionId = this.OptionIdval;
            if (OptionId > 0) {
                this.$store
                    .dispatch("getarminsubjectassigned", OptionId)
                    .then((resp) => {
                        this.armitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getsubjectinsubjectassigned () {
            this.studentitems = null;
            this.subjectitems = null;
            this.homeworkitem = null;
            this.SubjectIdval = 0;
            this.onloader = "flex";
            let ArmId = this.ArmIdval;
            if (ArmId > 0) {
                this.$store
                    .dispatch("getschsubjectinsubjectassigned", ArmId)
                    .then((resp) => {
                        this.subjectitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        handleFileUpload () {
            this.file = this.$refs.file.files[0];
        },
        submitFile () {
            this.onloader = "flex";
            var form = new FormData();
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let formalurl = this.DocPathval;
            let doctype = "doc";
            form.append("username", username);
            form.append("accesskey", accesskey);
            form.append("formalurl", formalurl);
            form.append("doctype", doctype);
            form.append("file", this.file);
            this.$store
                .dispatch("uploadfile", form)
                .then((resp) => {
                    this.DocPathval = resp;
                    this.uploadedimage = this.$store.state.auth.baseurl;
                    this.onloader = "none";
                    this.ShowAlertSuccess('Uploaded Successfully', '');
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        frontEndDateFormat (date) {
            return moment(date).format("YYYY-MM-DD");
        },
        backEndDateFormat (date) {
            return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        },

    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        } else {
            this.getregsession();
        }
    },
};
</script>

<style></style>
